(function (angular, app) {
    'use strict';

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.accessibilityStatement', {
                url: '/accessibility-statement',
                data: {
                    name: 'accessibility-statement'
                },
                metaTags: {
                    title: ['$filter', function ($filter) {
                        return $filter('translate')('Accessibility Statement');
                    }]
                },
                views: {
                    '@': {
                        templateUrl: 'template/views/accessibility-statement/index.html',
                        controller: 'AccessibilityStatementCtrl'
                    }
                }
            });
        }])
        .controller('AccessibilityStatementCtrl', ['$scope', 'Config', function ($scope, config) {
            $scope.accessibilityStatement = config.retailer.settings.accessibilityStatement;
        }]);

})(angular, app);
